import {preventDefaultEvent} from '../../../../common/shared/utils/preventDefaultEvent.function';
import {twMerge} from '../../../../common/twMerge';
import {BadgeType} from '../../../../graphql/generated/types';
import {SeparatorType} from '../../../atoms/Separator/SeparatorType.enum';
import {Text} from '../../../atoms/Text/Text';
import {Metadata} from '../../Metadata/Metadata';
import {BannerItemInfoProps} from './BannerItemInfoProps.interface';

export function BannerItemInfo({
  isParentCarouselHasIndicator,
  shouldShowBadges,
  isPlaying,
  titleImageSrc,
  titleText,
  caption,
  statusBadge,
  descBadges,
  descTexts,
  discountRateText,
  ...props
}: BannerItemInfoProps) {
  return (
    <div
      className="absolute bottom-0 left-0 w-full px-16pxr pb-16pxr flex flex-col items-center justify-end"
      {...props}
    >
      {!isPlaying && !!titleImageSrc && (
        <div
          className="w-[800px] h-400pxr flex items-end justify-center"
          style={{
            transform: 'scale(0.3)',
            transformOrigin: 'bottom',
          }}
        >
          <img
            className="max-w-full max-h-full object-scale-down"
            src={titleImageSrc}
            alt={titleText || '배너 타이틀'}
            onSelect={preventDefaultEvent}
            onDragStart={preventDefaultEvent}
            onContextMenu={preventDefaultEvent}
          />
        </div>
      )}
      {!isPlaying && !titleImageSrc && titleText && (
        <div className="w-[240px]">
          <Text className="font-large2-bold text-center text-static-mono-white line-clamp-2 text-ellipsis keep-word-anywhere whitespace-pre-line">
            {titleText}
          </Text>
        </div>
      )}
      {!isPlaying && caption && (
        <div className="mt-4pxr w-[240px]">
          <Text
            className="font-small2 line-clamp-1 break-all text-center text-static-mono-white text-ellipsis"
            aria-hidden={true}
          >
            {caption}
          </Text>
        </div>
      )}
      {!isPlaying && shouldShowBadges && (
        <>
          <Metadata
            badgeList={
              [
                ...(descBadges ? descBadges : []),
                ...(statusBadge ? [statusBadge] : []),
              ] as BadgeType[]
            }
            discountRateText={discountRateText}
            texts={descTexts}
            separatorType={SeparatorType.Dot}
            className="mt-8pxr"
            subtitleClassName={twMerge([
              'my-auto text-static-mono-white opacity-70',
              (descBadges && descBadges.length > 0) ||
              (statusBadge && statusBadge.length > 0)
                ? 'ml-4pxr'
                : undefined,
            ])}
            separatorClassName="text-static-mono-white"
            useStaticDot={true}
          />
        </>
      )}
    </div>
  );
}
